/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordValidationRuleName } from './PasswordValidationRuleName';
import {
    PasswordValidationRuleNameFromJSON,
    PasswordValidationRuleNameFromJSONTyped,
    PasswordValidationRuleNameToJSON,
    PasswordValidationRuleNameToJSONTyped,
} from './PasswordValidationRuleName';

/**
 * 
 * @export
 * @interface BasePasswordValidationRule
 */
export interface BasePasswordValidationRule {
    /**
     * 
     * @type {PasswordValidationRuleName}
     * @memberof BasePasswordValidationRule
     */
    name: PasswordValidationRuleName;
}



/**
 * Check if a given object implements the BasePasswordValidationRule interface.
 */
export function instanceOfBasePasswordValidationRule(value: object): value is BasePasswordValidationRule {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BasePasswordValidationRuleFromJSON(json: any): BasePasswordValidationRule {
    return BasePasswordValidationRuleFromJSONTyped(json, false);
}

export function BasePasswordValidationRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasePasswordValidationRule {
    if (json == null) {
        return json;
    }
    return {
        
        'name': PasswordValidationRuleNameFromJSON(json['name']),
    };
}

export function BasePasswordValidationRuleToJSON(json: any): BasePasswordValidationRule {
    return BasePasswordValidationRuleToJSONTyped(json, false);
}

export function BasePasswordValidationRuleToJSONTyped(value?: BasePasswordValidationRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': PasswordValidationRuleNameToJSON(value['name']),
    };
}

